import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);
/* eslint-disable */


export default new Vuex.Store({
    state: {
        token: localStorage.getItem("coach_school_token") || null,
        userInfo: JSON.parse(localStorage.getItem("coach_school_userInfo")) || null,
        redirectPathLink: JSON.parse(localStorage.getItem("redirectPathLink")) || null,
    },
    mutations: {
        retrieveToken(state, token) {
            state.token = token.data.token;
            state.userInfo = token.data.user;
        },
        storeRedirectPath(state, data) {
            state.redirectPathLink = data;
        },
        declaration(state, data) {
            state.declaration = data;
        },
        destroyToken(state) {
            state.token = null;
            state.userInfo = null;
            state.redirectPathLink = null;
        }
    },
    getters: {
        loggedIn(state) {
            return state.token !== null;
        }
    },
    actions: {
        destroyToken(context) {
            if (context.getters.loggedIn) {
                return new Promise(resolve => {
                    localStorage.removeItem("coach_school_token");
                    localStorage.removeItem("coach_school_userInfo");
                    localStorage.removeItem("redirectPathLink");
                    context.commit("destroyToken");
                    resolve({
                        success: true
                    });
                });
            }
        },
        declaration(context, data) {
            return new Promise((resolve, reject) => {
                axios.get(`https://kc0dn3da9f.execute-api.us-east-1.amazonaws.com/dev/base/application/accept-terms/${data.applicant_id}`).then((res) => {
                    localStorage.setItem(
                        "intern_declaration", data.data
                    );
                    resolve(context.commit("declaration", data.data));
                }).catch((err) => {
                    reject(err);
                })
            });
        },
        storeRedirectPath(context, data) {
            return new Promise((resolve, reject) => {
                localStorage.setItem(
                    "redirectPathLink",
                    JSON.stringify(data)
                );
                resolve(context.commit("storeRedirectPath", data));
            });
        },
        retrieveToken(context, credentials) {
            return new Promise((resolve, reject) => {
                axios
                  .post(
                    `${process.env.VUE_APP_COMPANY_URL}/coach-school-login`,
                    {
                      email: credentials.email,
                      password: credentials.password
                    }
                  )
                  .then(res => {
                    const token = res.data.data.token;
                    localStorage.setItem("coach_school_token", token);
                    localStorage.setItem(
                      "coach_school_userInfo",
                      JSON.stringify(res.data.data.user)
                    );
                    context.commit("retrieveToken", {
                      data: res.data.data
                    });
                    resolve(res.data.data);
                  })
                  .catch(err => {
                    reject(err);
                  });
            });
        },
    },
    modules: {}
});
